var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoney = function SvgIconMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M24 10.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 6a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M28 20.5H4a2.005 2.005 0 0 1-2-2v-12a2.005 2.005 0 0 1 2-2h24a2.005 2.005 0 0 1 2 2v12a2.003 2.003 0 0 1-2 2m0-14H4v12h24zM30 22.5H2v2h28zM30 26.5H2v2h28z"
  })));
};
export default SvgIconMoney;